import request from '@/utils/request'

// 登录方法
export function login(username, password, code, uuid) {
  const data = {
    username,
    password,
    code,
    uuid
  }
  return request({
    url: '/login',
    method: 'post',
    data: data
  })
}

// 获取用户详细信息
export function getInfo() {
  return request({
    url: '/getInfo',
    method: 'get'
  })
}

export function getPassword(data) {
  // console.log("data"+JSON.stringify(data));
  return request({
    url: '/login/getpassword',
    method: 'post',
    data:data
  })
}

// 退出方法
export function logout() {
  return request({
    url: '/logout',
    method: 'post'
  })
}

// 获取图片验证码
export function getCodeImg() {
  return request({
    url: '/captchaImage',
    method: 'get'
  })
}
// 获取用户权限
export function getUserPower() {
  return request({
    url: '/login/getUserPower',
    method: 'get'
  })
}
// 获取短信验证码
export function getCodeSMS(telephone) {
  return request({
    url: '/captchaSMS/'+telephone,
    method: 'get'
  })
}
// 获取短信验证码
export function telephoneLogin(data) {
  return request({
    url: '/login/telephoneLogin',
    method: 'post',
    data:data
  })
}
export function resetPassword(data) {
  return request({
    url: '/login/resetPassword',
    method: 'post',
    data:data
  })
}
export function checkTelephone(telephone) {
  return request({
    url: '/login/checkTelephone/' + telephone,
    method: 'get',
  })
}
export function resetUserName(username) {
  return request({
    url: '/login/resetUserName/' + username,
    method: 'get',
  })
}
export function updataTelephone(telephone) {
  return request({
    url: '/login/updataTelephone/' +telephone,
    method: 'get',
  })
}

export function checkUserName(username) {
  return request({
    url: '/login/checkUserName/' + username,
    method: 'get',
  })
}
export function showUserInfo() {
  return request({
    url: '/login/showUserInfo',
    method: 'get'
  })
}
export function checkCompanyName(companyName) {
  return request({
    url: '/company/checkCompanyName/' + companyName,
    method: 'get',
  })
}

// 注册方法
export function register(data) {
  return request({
    url: '/login/register',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js